/* Savage Gear — carrusel del hero.
   Solo conmuta atributos; toda la transición vive en CSS para que corra
   fuera del hilo principal. */

(() => {
  'use strict';

  class SgHero {
    constructor(root) {
      this.root = root;
      this.slides = [...root.querySelectorAll('.sg-hero__slide')];
      this.dots = [...root.querySelectorAll('.sg-hero__dot')];
      this.live = root.querySelector('[data-sg-live]');
      this.i = 0;
      this.timer = null;
      this.pausado = false;

      this.intervalo = parseInt(root.dataset.intervalo, 10) || 6000;
      this.autoplay =
        root.dataset.autoplay === 'true' &&
        this.slides.length > 1 &&
        !matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.slides.length <= 1) {
        const nav = root.querySelector('.sg-hero__nav');
        if (nav) nav.hidden = true;
        return;
      }

      root.querySelectorAll('[data-sg-prev]').forEach((b) =>
        b.addEventListener('click', () => this.manual(this.i - 1))
      );
      root.querySelectorAll('[data-sg-next]').forEach((b) =>
        b.addEventListener('click', () => this.manual(this.i + 1))
      );
      this.dots.forEach((d, n) => d.addEventListener('click', () => this.manual(n)));

      this.btnPausa = root.querySelector('[data-sg-pause]');
      if (this.btnPausa) {
        this.btnPausa.addEventListener('click', () => {
          this.pausado ? this.reanudar(true) : this.pausar(true);
        });
      }

      // Se detiene mientras el puntero está encima o el foco está dentro:
      // nada peor que un carrusel que cambia justo cuando ibas a hacer clic.
      root.addEventListener('pointerenter', () => this.pausar());
      root.addEventListener('pointerleave', () => this.reanudar());
      root.addEventListener('focusin', () => this.pausar());
      root.addEventListener('focusout', (e) => {
        if (!root.contains(e.relatedTarget)) this.reanudar();
      });

      // Fuera de pantalla no tiene sentido gastar ciclos ni cambiar de slide
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          (es) => es.forEach((e) => (e.isIntersecting ? this.reanudar() : this.pausar())),
          { threshold: 0.25 }
        ).observe(root);
      }

      // Con la pestaña oculta el navegador limita los timers y al volver se
      // dispararían varios cambios seguidos.
      document.addEventListener('visibilitychange', () =>
        document.hidden ? this.pausar() : this.reanudar()
      );

      root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.manual(this.i - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.manual(this.i + 1); }
      });

      this.ir(0);
      this.arrancar();
    }

    ir(n) {
      const total = this.slides.length;
      this.i = ((n % total) + total) % total;
      this.slides.forEach((s, k) => {
        const activo = k === this.i;
        s.dataset.active = String(activo);
        // Los slides ocultos salen del orden de tabulación y del lector
        s.setAttribute('aria-hidden', String(!activo));
        s.querySelectorAll('a, button').forEach((el) =>
          activo ? el.removeAttribute('tabindex') : el.setAttribute('tabindex', '-1')
        );
      });
      this.dots.forEach((d, k) => d.setAttribute('aria-current', String(k === this.i)));
      if (this.live) this.live.textContent = `Slide ${this.i + 1} de ${total}`;
    }

    // Un cambio pedido por el usuario detiene el automático: si sigue girando
    // solo, se siente que la interfaz le pelea.
    manual(n) {
      this.ir(n);
      this.pausar(true);
    }

    arrancar() {
      if (!this.autoplay || this.pausado || this.timer) return;
      this.timer = setInterval(() => this.ir(this.i + 1), this.intervalo);
    }

    detener() {
      clearInterval(this.timer);
      this.timer = null;
    }

    pausar(porUsuario) {
      this.detener();
      if (porUsuario) {
        this.pausado = true;
        this.marcarPausa();
      }
    }

    reanudar(porUsuario) {
      if (porUsuario) {
        this.pausado = false;
        this.marcarPausa();
      }
      if (!this.pausado) this.arrancar();
    }

    marcarPausa() {
      if (!this.btnPausa) return;
      this.btnPausa.setAttribute('aria-pressed', String(this.pausado));
      this.btnPausa.setAttribute(
        'aria-label',
        this.pausado ? 'Reanudar presentación' : 'Pausar presentación'
      );
      this.btnPausa.dataset.pausado = String(this.pausado);
    }
  }

  const init = () => document.querySelectorAll('[data-sg-hero]').forEach((h) => new SgHero(h));

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
  document.addEventListener('shopify:section:load', init);
})();
